import { GeomapService } from "../../geomap/geomapService"
import { NotificationHelper } from "../util/notificationHelper";
import { Commands } from "../util/commandManager";
import { CommandManagerAPI } from "../../commonInterfaces";
import {AppHelper} from "../../appHelper";
import {HTTPService, JsonResultClass} from "../util/httpManager";
import React from "react";
import {Helper} from "../util/helper";

export default class GMEmbedApi extends React.Component<GMEmbedApiProps, any> {
    private _geomapService: GeomapService;
    private _apiKey: string;
    private _frameId = kendo.guid();

    constructor(props) {
        super(props);
        this._geomapService = new GeomapService();
    }

    private _reload = () => {
        const el = document.getElementById(this._frameId);
        if (el != null)
            (el as HTMLIFrameElement).src += '';
    }

    private _getsearchPart = () => {
        let entity = this.props.entity instanceof Object ? this.props.entity : null;
        let lat = typeof this.props.latitude === "number" ? this.props.latitude : this.internalLaLongEval(this.props.latitude, entity);
        let lng = typeof this.props.longitude === "number" ? this.props.longitude : this.internalLaLongEval(this.props.longitude, entity);

        if (lat != null && lng != null && (lat !== 0 || lng !== 0)) {
            return `q=${lat},${lng}`;
        }
        else {
            return `q=${this.props.address || null}`;
        }
    }

    private internalLaLongEval = (codeToEval: string, entity): any => {
        return eval(codeToEval);
    }

    componentDidMount() {
        if (!this.props.apiKey) {
            this._geomapService.getApiKey().then((result) => {
                this._apiKey = result;
                this.setState({});
            }, (result) => {
                NotificationHelper.showErrorMessage(result);
            });
        }
        else {
            this._apiKey = this.props.apiKey;
        }
        if (this.props.commandManager != null) {
            this.props.commandManager.registerExecutor("updateGMEmbeddedApi", (command, data) => {
                if (command == Commands.REFRESH)
                    this._reload();
            });
        }
    }

    render() {
        if (this._apiKey) {
            let searchPart = this._getsearchPart();
            let zoom = this.props.zoom || 12;
            let srcString = `https://www.google.com/maps/embed/v1/search?key=${this._apiKey}&${searchPart}&zoom=${zoom}`;


            return (<iframe
                data-id={"gmEmbedApi"}
                id={this._frameId}
                referrerPolicy="unsafe-url"
                width="100%"
                height="100%"
                frameBorder="0"
                style={this.props.style || { border: 0 }}
                src={srcString}
                allowFullScreen>
            </iframe>);
        }
        else {
            return null;
        }
    }
}

export function OpenAddressCoordinatesEmbedded(api: CommandManagerAPI) {
    if (api == null) {
        console.warn("OpenAddressCoordinatesEmbedded - CommandManager is undefined" );
        return
    }
    
    //send refresh
    api.runCommand("updateGMEmbeddedApi", Commands.REFRESH);

    //.side-tabs__quick-tab
    if ($("#side-tabs .fa-map-signs").length == 1) {
        $("#side-tabs .fa-map-signs").parent().trigger('click');
    } else {
        $(".side-tabs__quick-tab").trigger('click');

        this.elementReady("#side-tabs .fa-map-signs").then(() => {
            $("#side-tabs .fa-map-signs").parent().trigger('click');
        });
    }
}

export function OpenAddressCoordinates(adrNr: string, api?: CommandManagerAPI) {
    const embeddedMaps = document.querySelectorAll('[data-id="gmEmbedApi"]');
    
    if (embeddedMaps.length == 0)
    {
        if (Helper.isNullOrEmpty(adrNr)) {
            console.warn("OpenAddressCoordinates - adrNr is undefined" );
            return
        }

        const  getAddressInfo = (adrNr: string): Promise<boolean> => {
            return new Promise<boolean>(async (resolve) => {
                const result = await HTTPService.get<JsonResultClass>("Address/Get", { id: adrNr })
                if (Helper.hasValue(result) && result.Code === 0) {
                    const newEntity = result.Data;

                    const common = new AppHelper();
                    common.updateEntity(newEntity)
                    common.evalAction(`addToGeomapRoute('Address')`);

                    resolve(true);
                } else
                    console.warn("OpenAddressCoordinates - adrNr not found. Code: " + result.Code + ", Message: " + result.Message );
                resolve(false);
            });
        }

        getAddressInfo(adrNr).then()
    }
    else {
        OpenAddressCoordinatesEmbedded(api)
    }
} 

export interface GMEmbedApiProps {
    apiKey?: string;
    style?: React.CSSProperties;
    latitude?: string | number;
    longitude?: string | number;
    address?: string;
    entity?: Object;
    zoom?: number;
    commandManager: CommandManagerAPI;
}
